/** Roles allowed on each public login portal */
export const CLIENT_LOGIN_ROLES = ['client', 'client_team'];
export const TESTER_LOGIN_ROLES = ['tester'];

const STAFF_LOGIN_ROLES = ['admin', 'platform_owner', 'platform_test_manager'];
const LOGIN_PATHS = ['/login', '/tester-login', '/client-login'];

export function isClientLoginRole(role) {
  return CLIENT_LOGIN_ROLES.includes(role);
}

export function isTesterLoginRole(role) {
  return role === 'tester';
}

export function dashboardPathForRole(role) {
  return '/app/dashboard';
}

export function loginPathForRole(role) {
  if (role === 'tester') return '/tester-login';
  if (CLIENT_LOGIN_ROLES.includes(role)) return '/client-login';
  if (STAFF_LOGIN_ROLES.includes(role)) return '/login';
  return '/login';
}

export function loginPathForStoredRole() {
  return loginPathForRole(localStorage.getItem('lastUserRole'));
}

export function clearTokenAndRedirectToLogin() {
  localStorage.removeItem('token');
  const redirectPath = loginPathForStoredRole();
  localStorage.removeItem('lastUserRole');
  const current = window.location.pathname;
  if (!LOGIN_PATHS.includes(current)) {
    window.location.href = redirectPath;
  }
}
